export default __webpack_public_path__ + "static/media/failed.4d189169.svg";